/**
 * Simulation Filters Component
 * Displays filter dropdowns for simulations list
 */
import React from 'react';
import { Button } from '../ui/button';
import { ArrowUpDown } from 'lucide-react';

export const SimulationFilters = ({
  filterStatus,
  setFilterStatus,
  filterCarrier,
  setFilterCarrier,
  filterCommercial,
  setFilterCommercial,
  filterBusinessStatus,
  setFilterBusinessStatus,
  sortBy,
  setSortBy,
  commercialNames = [],
  language = 'fr',
  onClear
}) => {
  const hasActiveFilters = filterStatus !== 'all' || filterCarrier !== 'all' || 
                           filterCommercial !== 'all' || filterBusinessStatus !== 'all';

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="filters-row">
      <span className="text-xs text-slate-500 flex items-center gap-1">
        {language === 'fr' ? 'Filtres :' : 'Filters:'}
      </span>
      
      <select 
        value={filterStatus} 
        onChange={(e) => setFilterStatus(e.target.value)}
        className="text-xs border rounded-md px-2 py-1.5 bg-white text-slate-700 focus:ring-1 focus:ring-blue-500"
        data-testid="filter-status"
      >
        <option value="all">{language === 'fr' ? 'Tous statuts' : 'All statuses'}</option>
        <option value="pending">{language === 'fr' ? 'En attente' : 'Pending'}</option>
        <option value="approved">GO</option>
        <option value="rejected">NO GO</option>
        <option value="pending_review">{language === 'fr' ? 'À l\'étude' : 'Under Review'}</option>
      </select>
      
      <select 
        value={filterCarrier} 
        onChange={(e) => setFilterCarrier(e.target.value)}
        className="text-xs border rounded-md px-2 py-1.5 bg-white text-slate-700 focus:ring-1 focus:ring-blue-500"
        data-testid="filter-carrier"
      >
        <option value="all">{language === 'fr' ? 'Tous porteurs' : 'All carriers'}</option>
        <option value="CCD">CCD</option>
        <option value="CLIENT">CLIENT</option>
        <option value="MIXTE">MIXTE</option>
      </select>
      
      <select 
        value={filterCommercial} 
        onChange={(e) => setFilterCommercial(e.target.value)}
        className="text-xs border rounded-md px-2 py-1.5 bg-white text-slate-700 focus:ring-1 focus:ring-blue-500"
        data-testid="filter-commercial"
      >
        <option value="all">{language === 'fr' ? 'Tous commerciaux' : 'All users'}</option>
        {commercialNames.map(name => (
          <option key={name} value={name}>{name}</option>
        ))}
      </select>
      
      <select 
        value={filterBusinessStatus} 
        onChange={(e) => setFilterBusinessStatus(e.target.value)}
        className="text-xs border rounded-md px-2 py-1.5 bg-white text-slate-700 focus:ring-1 focus:ring-blue-500"
        data-testid="filter-business-status"
      >
        <option value="all">{language === 'fr' ? 'Tous dossiers' : 'All status'}</option>
        <option value="in_progress">{language === 'fr' ? '⏳ En cours' : '⏳ In Progress'}</option>
        <option value="signed">{language === 'fr' ? '✅ Signés' : '✅ Signed'}</option>
        <option value="nogo">{language === 'fr' ? '🚫 NO GO' : '🚫 NO GO'}</option>
        <option value="lost">{language === 'fr' ? '❌ Perdus' : '❌ Lost'}</option>
      </select>
      
      <div className="flex items-center gap-1 ml-2 text-xs text-slate-500">
        <ArrowUpDown className="w-3.5 h-3.5" />
        {language === 'fr' ? 'Tri :' : 'Sort:'}
      </div>
      
      <select 
        value={sortBy} 
        onChange={(e) => setSortBy(e.target.value)}
        className="text-xs border rounded-md px-2 py-1.5 bg-white text-slate-700 focus:ring-1 focus:ring-blue-500"
        data-testid="sort-select"
      >
        <option value="date_desc">{language === 'fr' ? 'Date ↓' : 'Date ↓'}</option>
        <option value="date_asc">{language === 'fr' ? 'Date ↑' : 'Date ↑'}</option>
        <option value="ca_desc">{language === 'fr' ? 'CA HT ↓' : 'Revenue ↓'}</option>
        <option value="ca_asc">{language === 'fr' ? 'CA HT ↑' : 'Revenue ↑'}</option>
        <option value="commission_desc">{language === 'fr' ? 'Commission ↓' : 'Commission ↓'}</option>
      </select>
      
      {hasActiveFilters && onClear && (
        <Button 
          variant="ghost" 
          size="sm" 
          className="text-xs h-7 text-red-500 hover:text-red-700"
          onClick={onClear}
        >
          {language === 'fr' ? 'Effacer' : 'Clear'}
        </Button>
      )}
    </div>
  );
};

export default SimulationFilters;
